import React, { Component } from "react";
import { Alert, Col, Row, Spinner } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import toastr from "toastr";
import Web3 from "web3";
import LaunchPad from "../libs/launchPad";
import ProjectLogo from "../images/shield-vault.png";
import Seo from "../components/seo";
import { getBalances, getPresaleDetails } from "../libs/multicall";
import Countdown from "../components/countdown";

class ProjectDetails extends Component {
  launchPad = new LaunchPad(this.props.config);
  details = {};
  subscribed = false;
  listeningToJoin = false;
  currentAccount = this.props.appStatus.account;
  presaleAddress = "";
  constructor(props) {
    super(props);

    const { presaleAddress } = this.props.match.params;
    this.presaleAddress = presaleAddress;

    this.state = {
      loading: true,
      presaleAddress: presaleAddress,
      status: "",
      progress: "0",
      rate: Web3.utils.toBN("0"),
      softCap: Web3.utils.toBN("0"),
      hardCap: Web3.utils.toBN("0"),
      disableBuy: true,
      bnbAmount: Web3.utils.toBN("0"),
      buying: false,
      raisedFunds: Web3.utils.toBN("0"),
      open: false,
      closed: false,
      balance: Web3.utils.toBN("0"),
      userBNBAmount: Web3.utils.toBN("0"),
      isOwner: false,
      isRefundAllowed: false,
      isClaiming: false,
      isClaimed: false,
      isDistributionMode: false,
      isTokenApproved: false,
      fundsWithdrawn: false,
      cancelingPresale: false,
      closingPresale: false,
      isCanceled: false,
      isWhitelistEnabled: false,
      isFundsWithdrawn: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.loadProjectDetails();
    //this.loadTokenDetails(true, true);
  }

  loadProjectDetails = async () => {
    const web3 = this.launchPad.web3;

    this.details = (
      await getPresaleDetails(this.props.config.factory, this.launchPad.web3, [
        this.presaleAddress,
      ])
    )[0];

    if (this.props.appStatus.connected) this.loadBalances();

    const raisedFunds = web3.utils.toBN(this.details.raisedFunds.hex);
    const softCap = web3.utils.toBN(this.details.softCap.hex);
    const hardCap = web3.utils.toBN(this.details.hardCap.hex);

    const presaleOpenAt = Web3.utils
      .toBN(this.details.presaleOpenAt.hex)
      .muln(1000)
      .toNumber();
    const presaleCloseAt = Web3.utils
      .toBN(this.details.presaleCloseAt.hex)
      .muln(1000)
      .toNumber();

    this.setState({
      presaleOpenAt,
      presaleCloseAt,
      bnbAmount: Web3.utils.toBN(this.details.bnbMin.hex),
    });

    let status = "";

    if (this.details.presaleIsApproved) {
      if (this.details.isCanceled) {
        this.setState({ canceled: true });
        status = "CANCELED - GET REFUND";
      } else if (Date.now() < presaleOpenAt) {
        status = "COMMING SOON";
      } else if (Date.now() > presaleCloseAt) {
        this.setState({
          closed: true,
          softCapNotReached: raisedFunds.lt(softCap),
        });
        status = "CLOSED";
      } else if (this.details.isDistributionMode) {
        this.setState({ claim: true });
        status = "CLAIM";
      } else {
        this.setState({ open: true });
        status = "OPEN";
      }
    } else {
      status = "NOT APPROVED";
    }

    this.setProgress(raisedFunds, softCap);

    this.setState({
      status,
      softCap,
      hardCap,
      raisedFunds,
      loading: false,
      isOwner: this.details.owner === this.currentAccount,
      isRefundAllowed: this.details.isRefundAllowed,
      allowCancel: !this.details.isCanceled && !this.details.isDistributionMode && Date.now() < presaleCloseAt,
      allowWithdraw:
        this.details.presaleIsApproved &&
        (Date.now() >= presaleCloseAt ||
          (hardCap.gtn(0) && raisedFunds.eq(hardCap))) &&
        !this.details.isCanceled &&
        !this.details.isFundsWithdrawn &&
        raisedFunds.gte(softCap),
      allowClose:
        this.details.presaleIsApproved &&
        raisedFunds.gte(softCap) &&
        Date.now() >= presaleOpenAt &&
        Date.now() < presaleCloseAt &&
        !this.details.isCanceled &&
        !this.details.isDistributionMode,
      allowDistribution:
        !this.details.isDistributionMode && this.details.isFundsWithdrawn,
      isDistributionMode: this.details.isDistributionMode,
      isCanceled: this.details.isCanceled,
      isWhitelistEnabled: this.details.onlyWhitelistedAllowed,
      isFundsWithdrawn: this.details.isFundsWithdrawn,
    });
  };
  setProgress = async (raisedFunds, softCap) => {
    let progress = softCap.gtn(0) ? Web3.utils.fromWei(
      raisedFunds
        .mul(Web3.utils.toBN(Web3.utils.toWei("1", "ether")))
        .div(softCap)
        .muln(100)
    ) : "0";
    progress = isNaN(progress) ? 0 : progress;
    this.setState({ progress });
  };
  loadBalances = async () => {
    this.setState({
      loadingBalances: true,
    });

    const web3 = this.launchPad.web3;

    const balances = await getBalances(
      this.presaleAddress,
      this.details.tokenX,
      this.props.appStatus.account,
      web3
    );

    const raisedFunds = web3.utils.toBN(balances.raisedFunds.hex);
    const softCap = web3.utils.toBN(balances.softCap.hex);
    const hardCap = web3.utils.toBN(balances.hardCap.hex);
    const userBNBAmount = web3.utils.toBN(balances.userBNBAmount.hex);

    this.setProgress(raisedFunds, softCap);

    this.setState({
      loadingBalances: false,
      disableBuy: true,
      isWhitelisted: balances.isWhitelisted,
      softCap,
      hardCap,
      userBNBAmount,
      raisedFunds,
      bnbAmount:
        this.details.bnbMin !== undefined
          ? Web3.utils.toBN(this.details.bnbMin.hex)
          : Web3.utils.toBN("0"),
      isClaimed: balances.isClaimed,
      isTokenApproved: Web3.utils.toBN(balances.allowance.hex).gtn(0),
    });

    web3.eth.getBalance(this.props.appStatus.account).then((balanceWei) =>
      this.setState({ balance: Web3.utils.toBN(balanceWei) }, () => {
        if (this.state.balance.gt(0)) this.setState({ disableBuy: false });
      })
    );
  };

  componentDidUpdate() {
    if (this.currentAccount !== this.props.appStatus.account) {
      this.currentAccount = this.props.appStatus.account;
      // if (this.busdSubscription) this.busdSubscription.unsubscribe();
      // if (this.tokenTransferSubscription)
      //   this.tokenTransferSubscription.unsubscribe();
      if (this.props.appStatus.connected && this.details.tokenX !== undefined) {
        this.setState({
          isOwner:
            this.currentAccount.toLowerCase() ===
            this.details.owner.toLowerCase(),
        });
        this.loadBalances();
      }
    }
    if (this.connected !== this.props.appStatus.connected) {
      this.connected = this.props.appStatus.connected;
      if (this.props.appStatus.connected && this.details.tokenX !== undefined)
        this.loadBalances();
    }

    if (
      !this.listeningToJoin &&
      this.props.appStatus.connected &&
      Web3.utils.isAddress(this.presaleAddress)
    ) {
      this.listeningToJoin = true;
      this.launchPad.onPresaleEvent(
        this.props.appStatus.provider,
        "Join",
        this.presaleAddress,
        this.onBuyOrRefund
      );
      this.launchPad.onPresaleEvent(
        this.props.appStatus.provider,
        "Refund",
        this.presaleAddress,
        this.onBuyOrRefund
      );
    }
  }
  onBuyOrRefund = async (error, transfers) => {
    if (this.props.appStatus.connected)
      this.loadBalances();
  };
  buy = async () => {
    this.setState({ buying: true });
    var buyModal = window.bootstrap.Modal.getInstance(
      document.getElementById("buyModal")
    );

    this.launchPad.join(
      this.props.appStatus.provider,
      this.state.presaleAddress,
      this.props.appStatus.account,
      this.state.bnbAmount,
      (hash) => {
        this.setState({ buying: false });
        this.notifyTxSubmitted("Buy", hash);
        // toastr.info(
        //   `<a target="_blank" href="${
        //     this.props.config.explorerUrl + "/tx/" + hash
        //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction submitted.</a>`,
        //   "Buy",
        //   { timeOut: 10000 }
        // );
        buyModal.hide();
      },
      (confirmationNumber, receipt) => {
        if (confirmationNumber === 0) {
          this.notifyTxCompleted("Buy", receipt.transactionHash);
          // toastr.success(
          //   `<a target="_blank" href="${
          //     this.props.config.explorerUrl + "/tx/" + receipt.transactionHash
          //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction completed.</a>`,
          //   "Buy",
          //   { timeOut: 10000 }
          // );
          // this.postBuyActions();
        }
      },
      async (error, receipt) => {
        this.setState({ buying: false });
        if (error.code !== 4001) {
          // 4001 = User denied transaction signature.
          if (receipt === undefined) this.notifyError(error.message, "Buy");
          else this.notifyTxFailed("Buy", receipt.transactionHash);
          // toastr.error(
          //   `<a target="_blank" href="${
          //     this.props.config.explorerUrl + "/tx/" + receipt.transactionHash
          //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction failed.</a>`,
          //   "Buy",
          //   { timeOut: 10000 }
          // );
          buyModal.hide();
        }
        await this.postBuyActions();
      }
    );
  };
  getRefund = async () => {
    this.setState({ inRefund: true });
    this.launchPad.getRefund(
      this.props.appStatus.provider,
      this.state.presaleAddress,
      this.props.appStatus.account,
      (hash) => {
        this.setState({ inRefund: false });
        this.notifyTxSubmitted("Refund", hash);
        // toastr.info(
        //   `<a target="_blank" href="${
        //     this.props.config.explorerUrl + "/tx/" + hash
        //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction submitted.</a>`,
        //   "Refund",
        //   { timeOut: 10000 }
        // );
      },
      (confirmationNumber, receipt) => {
        if (confirmationNumber === 0) {
          this.setState({ inRefund: false });
          this.notifyTxCompleted("Refund", receipt.transactionHash);
          // toastr.success(
          //   `<a target="_blank" href="${
          //     this.props.config.explorerUrl + "/tx/" + receipt.transactionHash
          //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction completed.</a>`,
          //   "Refund",
          //   { timeOut: 10000 }
          // );
          this.postBuyActions();
        }
      },
      async (error, receipt) => {
        this.setState({ inRefund: false });
        if (error.code !== 4001) {
          // 4001 = User denied transaction signature.
          if (receipt === undefined) this.notifyError(error.message, "Refund");
          else this.notifyTxFailed("Refund", receipt.transactionHash);
          // toastr.error(
          //   `<a target="_blank" href="${
          //     this.props.config.explorerUrl + "/tx/" + receipt.transactionHash
          //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction failed.</a>`,
          //   "Refund",
          //   { timeOut: 10000 }
          // );
        }
        this.postBuyActions();
      }
    );
  };
  claimTokens = async () => {
    this.setState({ isClaiming: true });
    this.launchPad.claimTokens(
      this.props.appStatus.provider,
      this.state.presaleAddress,
      this.props.appStatus.account,
      (hash) => {
        this.notifyTxSubmitted("Claim Tokens", hash);
        // toastr.info(
        //   `<a target="_blank" href="${
        //     this.props.config.explorerUrl + "/tx/" + hash
        //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction submitted.</a>`,
        //   "Claim Tokens",
        //   { timeOut: 10000 }
        // );
      },
      (confirmationNumber, receipt) => {
        if (confirmationNumber === 0) {
          this.setState({ isClaiming: false, isClaimed: true });
          this.notifyTxCompleted("Claim Tokens", receipt.transactionHash);
          // toastr.success(
          //   `<a target="_blank" href="${
          //     this.props.config.explorerUrl + "/tx/" + receipt.transactionHash
          //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction completed.</a>`,
          //   "Claim Tokens",
          //   { timeOut: 10000 }
          // );
          this.postBuyActions();
        }
      },
      async (error, receipt) => {
        this.setState({ isClaiming: false });
        if (error.code !== 4001) {
          // 4001 = User denied transaction signature.
          if (receipt === undefined)
            this.notifyError(error.message, "Claim Tokens");
          else this.notifyTxFailed("Claim Tokens", receipt.transactionHash);
          // toastr.error(
          //   `<a target="_blank" href="${
          //     this.props.config.explorerUrl + "/tx/" + receipt.transactionHash
          //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction failed.</a>`,
          //   "Claim Tokens",
          //   { timeOut: 10000 }
          // );
        }
        this.postBuyActions();
      }
    );
  };
  approveToken = async () => {
    this.setState({ approving: true });
    this.launchPad.approveToken(
      this.props.appStatus.provider,
      this.state.presaleAddress,
      this.details.tokenX,
      this.props.appStatus.account,
      (hash) => {
        this.notifyTxSubmitted("Approve", hash);
        // toastr.info(
        //   `<a target="_blank" href="${
        //     this.props.config.explorerUrl + "/tx/" + hash
        //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction submitted.</a>`,
        //   "Approve",
        //   { timeOut: 10000 }
        // );
      },
      (confirmationNumber, receipt) => {
        this.setState({ approving: false, isTokenApproved: true });
        if (confirmationNumber === 0) {
          this.notifyTxCompleted("Approve", receipt.transactionHash);
          // toastr.success(
          //   `<a target="_blank" href="${
          //     this.props.config.explorerUrl + "/tx/" + receipt.transactionHash
          //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction completed.</a>`,
          //   "Approve",
          //   { timeOut: 10000 }
          // );
          this.postBuyActions();
        }
      },
      async (error, receipt) => {
        this.setState({ approving: false });
        if (error.code !== 4001) {
          // 4001 = User denied transaction signature.
          if (receipt === undefined) this.notifyError(error.message, "Approve");
          else this.notifyTxFailed("Approve", receipt.transactionHash);
          // toastr.error(
          //   `<a target="_blank" href="${
          //     this.props.config.explorerUrl + "/tx/" + receipt.transactionHash
          //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction failed.</a>`,
          //   "Approve",
          //   { timeOut: 10000 }
          // );
        }
        this.postBuyActions();
      }
    );
  };
  withdrawRaisedFunds = async () => {
    this.setState({ withdrawingFunds: true });
    this.launchPad.withdrawRaisedFunds(
      this.props.appStatus.provider,
      this.state.presaleAddress,
      this.props.appStatus.account,
      (hash) => {
        this.notifyTxSubmitted("Withdraw Raised Funds", hash);
        // toastr.info(
        //   `<a target="_blank" href="${
        //     this.props.config.explorerUrl + "/tx/" + hash
        //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction submitted.</a>`,
        //   "Withdraw Raised Funds",
        //   { timeOut: 10000 }
        // );
      },
      (confirmationNumber, receipt) => {
        this.setState({ withdrawingFunds: false, isDistributionMode: true });
        if (confirmationNumber === 0) {
          this.notifyTxCompleted(
            "Withdraw Raised Funds",
            receipt.transactionHash
          );
          // toastr.success(
          //   `<a target="_blank" href="${
          //     this.props.config.explorerUrl + "/tx/" + receipt.transactionHash
          //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction completed.</a>`,
          //   "Withdraw Raised Funds",
          //   { timeOut: 10000 }
          // );
          this.loadProjectDetails();
        }
      },
      async (error, receipt) => {
        this.setState({ withdrawingFunds: false });
        if (error.code !== 4001) {
          // 4001 = User denied transaction signature.
          if (receipt === undefined)
            this.notifyError(error.message, "Withdraw Raised Funds");
          else
            this.notifyTxFailed(
              "Withdraw Raised Funds",
              receipt.transactionHash
            );
          // toastr.error(
          //   `<a target="_blank" href="${
          //     this.props.config.explorerUrl + "/tx/" + receipt.transactionHash
          //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction failed.</a>`,
          //   "Withdraw Raised Funds",
          //   { timeOut: 10000 }
          // );
        }
        this.loadProjectDetails();
      }
    );
  };
  cancelPresale = async () => {
    this.setState({ cancelingPresale: true });

    this.launchPad.cancelPresale(
      this.props.appStatus.provider,
      this.state.presaleAddress,
      this.props.appStatus.account,
      (hash) => {
        this.setState({ cancelingPresale: false });
        this.notifyTxSubmitted("Close Presale", hash);
        // toastr.info(
        //   `<a target="_blank" href="${
        //     this.props.config.explorerUrl + "/tx/" + hash
        //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction submitted.</a>`,
        //   "Cancel Presale",
        //   { timeOut: 10000 }
        // );
      },
      (confirmationNumber, receipt) => {
        this.setState({ allowCancel: false });
        if (confirmationNumber === 0) {
          this.notifyTxCompleted("Cancel Presale", receipt.transactionHash);
          // toastr.success(
          //   `<a target="_blank" href="${
          //     this.props.config.explorerUrl + "/tx/" + receipt.transactionHash
          //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction completed.</a>`,
          //   "Cancel Presale",
          //   { timeOut: 10000 }
          // );
          this.loadProjectDetails();
        }
      },
      async (error, receipt) => {
        this.setState({ cancelingPresale: false });
        if (error.code !== 4001) {
          // 4001 = User denied transaction signature.
          if (receipt === undefined)
            this.notifyError(error.message, "Cancel Presale");
          else this.notifyTxFailed("Cancel Presale", receipt.transactionHash);
          // toastr.error(
          //   `<a target="_blank" href="${
          //     this.props.config.explorerUrl + "/tx/" + receipt.transactionHash
          //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction failed.</a>`,
          //   "Cancel Presale",
          //   { timeOut: 10000 }
          // );
        }
        this.loadProjectDetails();
      }
    );
  };
  closePresale = async () => {
    this.setState({ closingPresale: true });
    this.launchPad.closePresale(
      this.props.appStatus.provider,
      this.state.presaleAddress,
      this.props.appStatus.account,
      (hash) => {
        this.setState({ closingPresale: false });
        this.notifyTxSubmitted("Close Presale", hash);
        // toastr.info(
        //   `<a target="_blank" href="${
        //     this.props.config.explorerUrl + "/tx/" + hash
        //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction submitted.</a>`,
        //   "Close Presale",
        //   { timeOut: 10000 }
        // );
      },
      (confirmationNumber, receipt) => {
        this.setState({ allowClose: false });
        if (confirmationNumber === 0) {
          this.notifyTxCompleted("Close Presale", receipt.transactionHash);
          // toastr.success(
          //   `<a target="_blank" href="${
          //     this.props.config.explorerUrl + "/tx/" + receipt.transactionHash
          //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction completed.</a>`,
          //   "Close Presale",
          //   { timeOut: 10000 }
          // );
          this.loadProjectDetails();
        }
      },
      async (error, receipt) => {
        this.setState({ closingPresale: false });
        if (error.code !== 4001) {
          // 4001 = User denied transaction signature.
          if (receipt === undefined)
            this.notifyError(error.message, "Close Presale");
          else this.notifyTxFailed("Close Presale", receipt.transactionHash);
          // toastr.error(
          //   `<a target="_blank" href="${
          //     this.props.config.explorerUrl + "/tx/" + receipt.transactionHash
          //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction failed.</a>`,
          //   "Close Presale",
          //   { timeOut: 10000 }
          // );
        }
        this.loadProjectDetails();
      }
    );
  };
  disableWhitelist = async () => {
    this.setState({ disablingWhitelist: true });
    this.launchPad.disableWhitelist(
      this.props.appStatus.provider,
      this.state.presaleAddress,
      this.props.appStatus.account,
      (hash) => {
        this.setState({ disablingWhitelist: false });
        this.notifyTxSubmitted("Disable Whitelist", hash);
        // toastr.info(
        //   `<a target="_blank" href="${
        //     this.props.config.explorerUrl + "/tx/" + hash
        //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction submitted.</a>`,
        //   "Disable Whitelist",
        //   { timeOut: 10000 }
        // );
      },
      (confirmationNumber, receipt) => {
        if (confirmationNumber === 0) {
          this.setState({
            disablingWhitelist: false,
            isWhitelistEnabled: false,
          });
          this.notifyTxCompleted("Disable Whitelist", receipt.transactionHash);
          // toastr.success(
          //   `<a target="_blank" href="${
          //     this.props.config.explorerUrl + "/tx/" + receipt.transactionHash
          //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction completed.</a>`,
          //   "Disable Whitelist",
          //   { timeOut: 10000 }
          // );
          this.loadProjectDetails();
        }
      },
      async (error, receipt) => {
        this.setState({ disablingWhitelist: false });
        if (error.code !== 4001) {
          // 4001 = User denied transaction signature.
          if (receipt === undefined)
            this.notifyError(error.message, "Disable Whitelist");
          else
            this.notifyTxFailed("Disable Whitelist", receipt.transactionHash);
          // toastr.error(
          //   `<a target="_blank" href="${
          //     this.props.config.explorerUrl + "/tx/" + receipt.transactionHash
          //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction failed.</a>`,
          //   "Disable Whitelist",
          //   { timeOut: 10000 }
          // );
        }
        this.loadProjectDetails();
      }
    );
  };
  enableDistribution = async () => {
    this.setState({ enablingDistribution: true });
    this.launchPad.enableDistributionMode(
      this.props.appStatus.provider,
      this.state.presaleAddress,
      this.props.appStatus.account,
      (hash) => {
        this.setState({ enablingDistribution: false });
        this.notifyTxSubmitted("Enable Distribution", hash);
        // toastr.info(
        //   `<a target="_blank" href="${
        //     this.props.config.explorerUrl + "/tx/" + hash
        //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction submitted.</a>`,
        //   "Enable Distribution",
        //   { timeOut: 10000 }
        // );
      },
      (confirmationNumber, receipt) => {
        if (confirmationNumber === 0) {
          this.setState({
            enablingDistribution: false,
            allowDistribution: false,
          });
          this.notifyTxCompleted(
            "Enable Distribution",
            receipt.transactionHash
          );

          // toastr.success(
          //   `<a target="_blank" href="${
          //     this.props.config.explorerUrl + "/tx/" + receipt.transactionHash
          //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction completed.</a>`,
          //   "Enable Distribution",
          //   { timeOut: 10000 }
          // );
          this.loadProjectDetails();
        }
      },
      async (error, receipt) => {
        this.setState({ enablingDistribution: false });
        if (error.code !== 4001) {
          // 4001 = User denied transaction signature.
          if (receipt === undefined)
            this.notifyError(error.message, "Enable Distribution");
          else
            this.notifyTxFailed("Enable Distribution", receipt.transactionHash);
          // toastr.error(
          //   `<a target="_blank" href="${
          //     this.props.config.explorerUrl + "/tx/" + receipt.transactionHash
          //   }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction failed.</a>`,
          //   "Enable Distribution",
          //   { timeOut: 10000 }
          // );
        }
        this.loadProjectDetails();
      }
    );
  };
  notifyTxSubmitted = (title, txHash) => {
    toastr.info(
      `<a target="_blank" href="${
        this.props.config.explorerUrl + "/tx/" + txHash
      }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction submitted.</a>`,
      title,
      { timeOut: 10000 }
    );
  };
  notifyTxCompleted = (title, txHash) => {
    toastr.success(
      `<a target="_blank" href="${
        this.props.config.explorerUrl + "/tx/" + txHash
      }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction completed.</a>`,
      title,
      { timeOut: 10000 }
    );
  };
  notifyTxFailed = (title, txHash) => {
    toastr.error(
      `<a target="_blank" href="${
        this.props.config.explorerUrl + "/tx/" + txHash
      }"><i className="fa fa-external-link me-2" aria-hidden></i>Transaction failed.</a>`,
      title,
      { timeOut: 10000 }
    );
  };
  notifyError = (text, title) => {
    toastr.error(text, title);
  };
  postBuyActions = async () => {
    // execute post buy actions

    // update token swap details and balances
    //await this.loadBalances();
    this.loadProjectDetails();
  };
  render() {
    const web3 = this.launchPad.web3;
    const search = this.props.location.search;
    const params = new URLSearchParams(search);
    return (
      <>
        <Seo pageTitle={params.get("name")} />
        {this.state.loading ? (
          <div className="text-center mt-5">
            <Spinner variant="warning" animation="border" size="md" />
          </div>
        ) : (
          <>
            {this.state.canceled ? (
              <Alert variant="warning">
                <i className="fa fa-exclamation-circle me-2"></i>
                This presale has been canceled.
              </Alert>
            ) : null}
            {this.state.closed && this.state.softCapNotReached ? (
              <Alert variant="warning">
                <i className="fa fa-exclamation-circle me-2"></i>
                Presale has expired and soft cap was not reached. This presale
                was not successful.&nbsp;
                {this.state.userBNBAmount.gtn(0) ? (
                  <>
                    Click&nbsp;
                    <button
                      onClick={(e) => this.getRefund()}
                      className="btn btn-sm btn-secondary"
                    >
                      {this.state.inRefund ? (
                        <Spinner
                          animation="border"
                          variant="warning"
                          size="sm"
                          className="me-2"
                        />
                      ) : null}
                      Get Refund
                    </button>{" "}
                    to get your refund.
                  </>
                ) : null}
              </Alert>
            ) : null}
            <div className="pp-detail-banner">
              <div className="container">
                <Row className="align-items-center">
                  <Col lg="5" md="5">
                    <div className="pp-card-top animation align-items-center">
                      <div className="icon-box">
                        <span>
                          <img src={ProjectLogo} alt="Swapz (Gold+)" />
                        </span>
                      </div>
                      <div className="pp-card-top">
                        <div className="title-box">
                          {this.details.onlyWhitelistedAllowed ? (
                            <span
                              className="badge project-access"
                              style={{
                                float: "right",
                              }}
                            >
                              Private
                            </span>
                          ) : null}
                          <h2>{this.details.tokenName} </h2>
                          <h2>
                            <a
                              href="https://shieldnetwork.io/"
                              target="_blank"
                              rel="noreferrer"
                              style={{ marginLeft: 0 }}
                            >
                              <i className="fas fa-globe-americas"></i>
                            </a>
                            <a
                              href="https://twitter.com/ShieldNet_io"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <i className="fab fa-twitter"></i>
                            </a>
                            <a
                              href="https://www.youtube.com/channel/UC9e3NXZGHxrVpudNILWLCfQ"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <i className="fab fa-youtube"></i>
                            </a>
                            <a
                              href="https://t.me/shieldnetio"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <i className="fab fa-telegram-plane"></i>
                            </a>
                          </h2>
                        </div>
                      </div>
                    </div>
                    <div className="ms-0">
                      <div className="mb-3">
                        <p className="text-muted">
                          {this.details.description}
                          {/* The Blockchain Agnostic, Zero Slippage DEX */}
                        </p>
                      </div>
                      {this.state.isOwner &&
                      (this.state.allowClose ||
                        this.state.allowCancel ||
                        this.state.allowWithdraw) ? (
                        <div
                          style={{
                            display: "inline-block",
                            marginRight: "5px",
                          }}
                          className="dropdown"
                        >
                          <button
                            className="btn btn-primary dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            Admin
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton1"
                          >
                            {this.state.allowCancel ? (
                              <li>
                                <button
                                  type="button"
                                  className="dropdown-item"
                                  onClick={(e) => this.cancelPresale()}
                                  disabled={this.state.cancelingPresale}
                                >
                                  {this.state.cancelingPresale ? (
                                    <Spinner
                                      animation="border"
                                      variant="warning"
                                      size="sm"
                                      className="me-2"
                                    />
                                  ) : null}
                                  Cancel Presale
                                </button>
                              </li>
                            ) : null}
                            {this.state.allowClose ? (
                              <li>
                                <button
                                  type="button"
                                  className="dropdown-item"
                                  onClick={(e) => this.closePresale()}
                                  disabled={this.state.closingPresale}
                                >
                                  {this.state.closingPresale ? (
                                    <Spinner
                                      animation="border"
                                      variant="warning"
                                      size="sm"
                                      className="me-2"
                                    />
                                  ) : null}
                                  Close Presale
                                </button>
                              </li>
                            ) : null}
                            {this.state.allowWithdraw ? (
                              <li>
                                <button
                                  type="button"
                                  className="dropdown-item"
                                  data-bs-toggle="modal"
                                  data-bs-target="#withdrawFundsModal"
                                >
                                  {this.state.withdrawingFunds ||
                                  this.state.approving ? (
                                    <Spinner
                                      animation="border"
                                      variant="warning"
                                      size="sm"
                                      className="me-2"
                                    />
                                  ) : null}
                                  Withdraw Raised Funds
                                </button>
                              </li>
                            ) : null}
                            {this.state.allowDistribution ? (
                              <li>
                                <button
                                  type="button"
                                  className="dropdown-item"
                                  onClick={(e) => this.enableDistribution()}
                                >
                                  {this.state.enablingDistribution ? (
                                    <Spinner
                                      animation="border"
                                      variant="warning"
                                      size="sm"
                                      className="me-2"
                                    />
                                  ) : null}
                                  Enable Distribution
                                </button>
                              </li>
                            ) : null}
                            {this.state.isWhitelistEnabled ? (
                              <li>
                                <button
                                  type="button"
                                  className="dropdown-item"
                                  onClick={(e) => this.disableWhitelist()}
                                  disabled={this.state.disablingWhitelist}
                                >
                                  {this.state.disablingWhitelist ? (
                                    <Spinner
                                      animation="border"
                                      variant="warning"
                                      size="sm"
                                      className="me-2"
                                    />
                                  ) : null}
                                  Disable Whitelist (Not Reversible)
                                </button>
                              </li>
                            ) : null}
                          </ul>
                        </div>
                      ) : null}
                      {(!this.details.onlyWhitelistedAllowed ||
                        this.state.isWhitelisted) &&
                      this.details.presaleIsApproved ? (
                        !this.details.isFundsWithdrawn &&
                        !this.details.canceled &&
                        !this.details.closed &&
                        this.state.open ? (
                          <>
                            <div style={{ display: "inline-block" }}>
                              <button
                                type="button"
                                className="btn btn-primary me-2"
                                data-bs-toggle="modal"
                                data-bs-target="#buyModal"
                                disabled={
                                  this.state.disableBuy ||
                                  !this.props.appStatus.connected ||
                                  this.props.appStatus.isWrongChainSelected
                                }
                              >
                                Buy
                              </button>
                            </div>
                            {web3.utils.toBN(this.state.balance).eqn(0) ? (
                              <Alert variant="danger" className="mt-3">
                                <i className="fa fa-exclamation-circle me-2"></i>
                                You have no BNB available. Please fund your
                                wallet.
                              </Alert>
                            ) : null}
                          </>
                        ) : null
                      ) : null}
                      {this.details.isDistributionMode &&
                      this.state.userBNBAmount.gtn(0) &&
                      !this.state.isClaimed ? (
                        <>
                          <div style={{ display: "inline-block" }}>
                            <button
                              type="button"
                              className="btn btn-primary me-2"
                              onClick={(e) => this.claimTokens()}
                              disabled={this.state.isClaiming}
                            >
                              {this.state.isClaiming ? (
                                <Spinner
                                  animation="border"
                                  variant="warning"
                                  size="sm"
                                  className="me-2"
                                />
                              ) : null}
                              Claim Tokens
                            </button>
                          </div>
                          <Alert variant="info" className="mt-3">
                            <i className="fa fa-exclamation-circle me-2"></i>
                            Presale is closed. Claim your tokens!
                          </Alert>
                        </>
                      ) : null}
                      {this.details.onlyWhitelistedAllowed &&
                      !this.state.isWhitelisted ? (
                        <Alert variant="warning" className="mt-3">
                          <i className="fa fa-exclamation-circle me-2"></i>
                          Your are not in the whitelist.
                        </Alert>
                      ) : null}
                    </div>
                  </Col>
                  <Col lg="5" md="7" className="offset-lg-2">
                    <div className="card card-img-holder bg-dark-transparent mx-auto mx-lg-0">
                      <div className="card-body px-3 py-2">
                        <div className="pp-card-info mt-2 text-white">
                          <div>
                            {this.state.status}
                            {(this.state.presaleOpenAt > Date.now()
                              ? this.state.presaleOpenAt
                              : this.state.presaleCloseAt > Date.now()
                              ? this.state.presaleCloseAt
                              : 0) > 0
                              ? ""
                              : " "}
                            {!this.details.isCanceled ? (
                              <>
                                {Date.now() < this.state.presaleCloseAt ? (
                                  <>
                                    {" - "}
                                    <Countdown
                                      date={
                                        this.state.presaleOpenAt > Date.now()
                                          ? this.state.presaleOpenAt
                                          : this.state.presaleCloseAt >
                                            Date.now()
                                          ? this.state.presaleCloseAt
                                          : 0
                                      }
                                    />
                                  </>
                                ) : null}
                              </>
                            ) : null}
                          </div>
                        </div>
                        {this.props.appStatus.connected ? (
                          <div
                            className="pp-card-info mt-2 text-white"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <p style={{ marginBottom: "0" }}>
                              Your contribution:{" "}
                              <span className="text-warning h4">
                                {web3.utils.fromWei(this.state.userBNBAmount)}{" "}
                                BNB
                              </span>
                            </p>
                            {this.state.isRefundAllowed &&
                            this.state.userBNBAmount.gtn(0) ? (
                              <>
                                &nbsp;
                                <button
                                  className="btn btn-sm btn-secondary"
                                  onClick={(e) => this.getRefund()}
                                  disabled={this.state.inRefund}
                                >
                                  {this.state.inRefund ? (
                                    <Spinner
                                      animation="border"
                                      variant="warning"
                                      size="sm"
                                      className="me-2"
                                    />
                                  ) : null}
                                  Get Refund
                                </button>
                              </>
                            ) : null}
                          </div>
                        ) : null}
                        <hr className="mb-2 mt-2" />
                        <div className="pp-card-info">
                          <div className="d-flex justify-content-between w-100">
                            <div className="pp-card-col w-200px">
                              Progress
                              <br />
                              <div className="pp-card-progress">
                                <div
                                  className="pp-card-progress-percent"
                                  style={{
                                    width:
                                      (parseFloat(this.state.progress) > 100
                                        ? 100
                                        : this.state.progress) + "%",
                                  }}
                                ></div>
                                <div className="pp-card-progress-label">
                                  <span>
                                    <b>
                                      {parseFloat(this.state.progress).toFixed(
                                        2
                                      )}
                                      %
                                    </b>
                                  </span>
                                  <span>
                                    <strong>
                                      {this.state.softCap.gtn(0) ? (
                                        <>
                                          {Web3.utils.fromWei(
                                            this.state.raisedFunds
                                          )}
                                          /
                                          {Web3.utils.fromWei(
                                            this.state.softCap
                                          )}{" "}
                                          BNB
                                        </>
                                      ) : (
                                        "TBA"
                                      )}
                                    </strong>
                                    {/* 112503.0610/112500 BUSD */}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            <div className="pp-detail-content pt-1">
              <div className="container">
                {/* {this.props.appStatus.connected ? (
              <Row>
                <Col className="mt-4 mt-md-0 mb-5">
                  <h3 style={{ color: "white" }}>Your transactions</h3>
                  <div className="table-responsive">
                    <table className="table mb-0 pp-table-info">
                      <tbody>
                        <tr className="card-header" style={{ border: "none" }}>
                          <td>No.</td>
                          <td style={{ textAlign: "right" }}>Token Amount</td>
                          <td>Block No.</td>
                          <td>Tx</td>
                        </tr>
                        {this.state.transfers
                          .sort((a, b) => a.blockNumber - b.blockNumber)
                          .map((transfer, index) => {
                            return (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td style={{ textAlign: "right" }}>
                                  {this.launchPad.web3.utils.fromWei(
                                    transfer.returnValues.value
                                  )}{" "}
                                  {this.state.tokenSymbol}
                                </td>
                                <td>
                                  <a
                                    target="_blank"
                                    rel="noreferrer"
                                    href={
                                      this.props.config.explorerUrl +
                                      "/block/" +
                                      transfer.blockNumber
                                    }
                                  >
                                    {transfer.blockNumber}
                                  </a>
                                </td>
                                <td>
                                  <a
                                    target="_blank"
                                    rel="noreferrer"
                                    href={
                                      this.props.config.explorerUrl +
                                      "/tx/" +
                                      transfer.transactionHash
                                    }
                                  >
                                    {transfer.transactionHash}
                                  </a>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </Col>
              </Row>
            ) : null} */}
                <Row>
                  <Col md="6" className="mt-4 mt-md-0 mb-5">
                    <h3 style={{ color: "white" }}>Token information</h3>
                    <div className="table-responsive">
                      <table className="table mb-0 pp-table-info">
                        <tbody>
                          <tr>
                            <td>Name</td>
                            <td className="text-right">
                              {this.details.tokenName}
                            </td>
                          </tr>
                          <tr>
                            <td>Token Symbol</td>
                            <td className="text-right">
                              {this.details.tokenSymbol}
                            </td>
                          </tr>
                          <tr>
                            <td>Total Supply</td>
                            <td className="text-right">
                              {parseFloat(
                                web3.utils.fromWei(
                                  web3.utils.toBN(
                                    this.details.tokenTotalSupply.hex
                                  )
                                )
                              ).toLocaleString()}
                            </td>
                          </tr>
                          <tr>
                            <td>Total Decimals</td>
                            <td className="text-right">
                              {web3.utils
                                .toBN(this.details.tokenDecimals.hex)
                                .toNumber()}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Col>
                  <Col md="6">
                    <h3 style={{ color: "white" }}>Pool information</h3>
                    <div className="table-responsive">
                      <table className="table mb-0 pp-table-info">
                        <tbody>
                          <tr>
                            <td>Opens</td>
                            <td className="text-right">
                              {web3.utils
                                .toBN(this.details.presaleOpenAt.hex)
                                .eqn(0)
                                ? "TBA"
                                : new Date(
                                    web3.utils
                                      .toBN(this.details.presaleOpenAt.hex)
                                      .muln(1000)
                                      .toNumber()
                                  ).toUTCString()}
                              {/* 2021-07-01 08:00:00 UTC */}
                            </td>
                          </tr>
                          {/* <tr>
                            <td>FCFS Opens</td>
                            <td className="text-right">
                              TBA
                              2021-07-01 12:45:00 UTC
                            </td>
                          </tr> */}
                          <tr>
                            <td>Closes</td>
                            <td className="text-right">
                              {web3.utils
                                .toBN(this.details.presaleCloseAt.hex)
                                .eqn(0)
                                ? "TBA"
                                : new Date(
                                    web3.utils
                                      .toBN(this.details.presaleCloseAt.hex)
                                      .muln(1000)
                                      .toNumber()
                                  ).toUTCString()}
                              {/* 2021-07-01 14:00:00 UTC */}
                            </td>
                          </tr>
                          <tr>
                            <td>Swap Rate</td>
                            <td className="text-right">
                              <span
                                id="idBusdConvert"
                                style={{ textTransform: "uppercase" }}
                              >
                                {web3.utils
                                  .toBN(this.details.rate.hex)
                                  .gtn(0) ? (
                                  <>
                                    1 BNB ={" "}
                                    {parseFloat(
                                      web3.utils.fromWei(
                                        web3.utils.toBN(this.details.rate.hex)
                                      )
                                    ).toLocaleString()}{" "}
                                    {this.details.tokenSymbol}
                                    {/* 1 BUSD = 200.0000 SWAPZ */}
                                  </>
                                ) : (
                                  "TBA"
                                )}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td>Soft Cap</td>
                            <td className="text-right">
                              <span style={{ textTransform: "uppercase" }}>
                                {web3.utils
                                  .toBN(this.details.softCap.hex)
                                  .gtn(0) ? (
                                  <>
                                    {web3.utils.fromWei(
                                      web3.utils.toBN(this.details.softCap.hex)
                                    )}{" "}
                                    BNB
                                  </>
                                ) : (
                                  "TBA"
                                )}
                              </span>
                            </td>
                          </tr>
                          {web3.utils.toBN(this.details.hardCap.hex).gt(0) && (
                            <tr>
                              <td>Hard Cap</td>
                              <td className="text-right">
                                <span style={{ textTransform: "uppercase" }}>
                                  {web3.utils
                                    .toBN(this.details.softCap.hex)
                                    .gtn(0) ? (
                                    <>
                                      {web3.utils.fromWei(
                                        web3.utils.toBN(
                                          this.details.hardCap.hex
                                        )
                                      )}{" "}
                                      BNB{" "}
                                    </>
                                  ) : (
                                    "TBA"
                                  )}
                                </span>
                              </td>
                            </tr>
                          )}
                          <tr>
                            <td>Minimum Buy</td>
                            <td className="text-right">
                              <span style={{ textTransform: "uppercase" }}>
                                {web3.utils
                                  .toBN(this.details.bnbMin.hex)
                                  .gtn(0) ? (
                                  <>
                                    {web3.utils.fromWei(
                                      web3.utils.toBN(this.details.bnbMin.hex)
                                    )}{" "}
                                    BNB
                                  </>
                                ) : (
                                  "TBA"
                                )}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td>Maximum Buy</td>
                            <td className="text-right">
                              <span style={{ textTransform: "uppercase" }}>
                                {web3.utils
                                  .toBN(this.details.bnbMax.hex)
                                  .gtn(0) ? (
                                  <>
                                    {web3.utils.fromWei(
                                      web3.utils.toBN(this.details.bnbMax.hex)
                                    )}{" "}
                                    BNB
                                  </>
                                ) : (
                                  "TBA"
                                )}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td>Total Participants</td>
                            <td className="text-right">
                              {web3.utils
                                .toBN(this.details.participants.hex)
                                .toNumber()}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>

            <div
              className="modal fade"
              id="buyModal"
              tabIndex="-1"
              aria-labelledby="buyModalLabel"
              aria-hidden="true"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
            >
              <div className="modal-dialog modal-md modal-dialog-centered">
                <div className="modal-content" style={{ borderRadius: "20px" }}>
                  <div className="modal-header">
                    <h5 className="modal-title" id="buyModalLabel">
                      Buy
                    </h5>
                    <div className="d-flex align-items-center">
                      <button
                        type="button"
                        className="btn-close me-2 text-light"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      >
                        <i className="fas fa-times"></i>
                      </button>
                    </div>
                  </div>
                  <div className="modal-body">
                    <div className="mb-3 d-flex align-items-center">
                      <label className="form-label mb-0 me-4">
                        Your balance:{" "}
                      </label>
                      <span className="h4 text-warning mb-0">
                        {this.state.loadingBalances ? (
                          <Spinner
                            animation="border"
                            variant="warning"
                            size="md"
                            className="me-2"
                          />
                        ) : (
                          parseFloat(
                            web3.utils.fromWei(this.state.balance)
                          ).toFixed(4)
                        )}{" "}
                        BNB
                      </span>
                    </div>
                    <div className="mb-3 d-flex align-items-center">
                      <label className="form-label mb-0 me-4">
                        Min. amount:{" "}
                      </label>
                      <span className="h4 text-warning mb-0">
                        {web3.utils.fromWei(
                          web3.utils.toBN(this.details.bnbMin.hex)
                        )}{" "}
                        BNB
                      </span>
                    </div>
                    <div className="mb-3 d-flex align-items-center">
                      <label className="form-label mb-0 me-4">
                        Max. amount:{" "}
                      </label>
                      <span className="h4 text-warning mb-0">
                        {web3.utils.fromWei(
                          web3.utils.toBN(this.details.bnbMax.hex)
                        )}{" "}
                        BNB
                      </span>
                    </div>
                    <div
                      className="mb-4 d-flex align-items-center justify-content-between"
                      style={{ columnGap: 10 + "px" }}
                    >
                      <div>
                        <span
                          className="ps-0"
                          style={{ border: 0 + "px", whiteSpace: "nowrap" }}
                        >
                          BNB Amount:
                        </span>
                        <div>&nbsp;</div>
                      </div>
                      <div style={{ width: "calc(100% - 12px)" }}>
                        <input
                          type="number"
                          id="inputAmountSwap"
                          className="form-control ms-2 me-1"
                          min={Web3.utils.fromWei(
                            Web3.utils.toBN(this.details.bnbMin.hex)
                          )}
                          max={Web3.utils.fromWei(
                            Web3.utils
                              .toBN(this.details.bnbMax.hex)
                              .gt(
                                this.state.balance.sub(
                                  Web3.utils.toBN("20000000000000000")
                                )
                              )
                              ? this.state.balance.sub(
                                  Web3.utils.toBN("20000000000000000")
                                )
                              : Web3.utils.toBN(this.details.bnbMax.hex)
                          )}
                          step="0.1"
                          value={web3.utils.fromWei(this.state.bnbAmount)}
                          onChange={(e) => {
                            if (
                              e.target.value === "" ||
                              isNaN(parseInt(e.target.value)) ||
                              Web3.utils
                                .toBN(this.details.bnbMin.hex)
                                .gt(
                                  Web3.utils.toBN(
                                    Web3.utils.toWei(e.target.value)
                                  )
                                )
                            ) {
                              this.setState({
                                bnbAmount: Web3.utils.toBN(
                                  this.details.bnbMin.hex
                                ),
                              });
                            } else if (
                              Web3.utils
                                .toBN(Web3.utils.toWei(e.target.value))
                                .gt(web3.utils.toBN(this.details.bnbMax.hex))
                            ) {
                              this.setState({
                                bnbAmount: Web3.utils.toBN(
                                  this.details.bnbMax.hex
                                ),
                              });
                            } else {
                              this.setState({
                                bnbAmount: Web3.utils.toBN(
                                  Web3.utils.toWei(e.target.value)
                                ),
                              });
                            }
                          }}
                          style={{ width: "calc(100% - 12px)" }}
                        />
                        <div
                          className="text-warning"
                          style={{ float: "right", paddingRight: "5px" }}
                        >
                          You will get{" "}
                          {this.state.bnbAmount === "0"
                            ? this.state.bnbAmount
                            : parseFloat(
                                web3.utils.fromWei(
                                  web3.utils
                                    .toBN(this.state.bnbAmount)
                                    .mul(web3.utils.toBN(this.details.rate.hex))
                                    .div(
                                      web3.utils.toBN(
                                        web3.utils.toWei("1", "ether")
                                      )
                                    )
                                )
                              ).toLocaleString()}{" "}
                          {this.details.tokenSymbol}
                        </div>
                      </div>
                      <div>
                        <button
                          className="btn btn-outline-primary"
                          onClick={(e) =>
                            this.setState({
                              bnbAmount: Web3.utils
                                .toBN(this.details.bnbMax.hex)
                                .gt(
                                  this.state.balance.sub(
                                    Web3.utils.toBN("20000000000000000")
                                  )
                                )
                                ? this.state.balance.sub(
                                    Web3.utils.toBN("20000000000000000")
                                  )
                                : Web3.utils
                                    .toBN(this.details.bnbMax.hex)
                                    .sub(this.state.userBNBAmount),
                            })
                          }
                          disabled={this.state.loadingBalances}
                        >
                          Max
                        </button>
                        <div>&nbsp;</div>
                      </div>
                    </div>
                    <div
                      className="get-start mt-3 text-center mb-2"
                      style={{ columnGap: 10 + "px" }}
                    >
                      <button
                        className="btn btn-primary w-100"
                        //data-bs-dismiss="modal"
                        onClick={this.buy}
                        disabled={
                          this.state.buying ||
                          this.state.loadingBalances ||
                          this.state.bnbAmount === 0
                        }
                      >
                        {this.state.buying ? (
                          <Spinner
                            animation="border"
                            variant="warning"
                            size="sm"
                            className="me-2"
                          />
                        ) : null}
                        SUBMIT
                      </button>
                      <div style={{ float: "right" }}>
                        <div>
                          <strong>
                            Swap rate: 1 BNB ={" "}
                            {parseFloat(
                              web3.utils.fromWei(
                                web3.utils.toBN(this.details.rate.hex)
                              )
                            ).toLocaleString()}{" "}
                            {this.details.tokenSymbol}
                          </strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal fade"
              id="withdrawFundsModal"
              tabIndex="-1"
              aria-labelledby="withdrawFundsModalLabel"
              aria-hidden="true"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
            >
              <div className="modal-dialog modal-md modal-dialog-centered">
                <div className="modal-content" style={{ borderRadius: "20px" }}>
                  <div className="modal-header">
                    <h5 className="modal-title" id="withdrawFundsModalLabel">
                      Withdraw Raised Funds
                    </h5>
                    <div className="d-flex align-items-center">
                      {!this.state.withdrawingFunds ? (
                        <button
                          type="button"
                          className="btn-close me-2 text-light"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        >
                          <i className="fas fa-times"></i>
                        </button>
                      ) : null}
                    </div>
                  </div>
                  <div className="modal-body">
                    <p>
                      Be sure to have enough tokens ({this.details.tokenName}{" "}
                      {this.details.tokenSymbol}) in your wallet to fulfill
                      presale distribution. Otherwise withdraw will fail.
                    </p>
                    <p>
                      1.&nbsp;
                      <button
                        type="button"
                        className="btn btn-sm- btn-primary w100"
                        disabled={
                          this.state.isTokenApproved || this.state.approving
                        }
                        onClick={(e) => this.approveToken()}
                      >
                        {this.state.approving ? (
                          <Spinner
                            animation="border"
                            variant="warning"
                            size="sm"
                            className="me-2"
                          />
                        ) : null}
                        Approve {this.details.tokenSymbol}
                      </button>
                    </p>
                    <p>
                      2.&nbsp;
                      <button
                        type="button"
                        className="btn btn-sm- btn-primary"
                        disabled={
                          !this.state.isTokenApproved ||
                          this.state.isDistributionMode
                        }
                        onClick={(e) => this.withdrawRaisedFunds()}
                      >
                        {this.state.withdrawingFunds ? (
                          <Spinner
                            animation="border"
                            variant="warning"
                            size="sm"
                            className="me-2"
                          />
                        ) : null}
                        Withdraw Raised Funds
                      </button>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* <div
              className="modal fade"
              id="approveModal"
              tabIndex="-1"
              aria-labelledby="approveModalLabel"
              aria-hidden="true"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
            >
              <div className="modal-dialog modal-md modal-dialog-centered">
                <div className="modal-content" style={{ borderRadius: "20px" }}>
                  <div className="modal-header">
                    <h5
                      className="modal-title text-dark"
                      id="approveModalLabel"
                    >
                      Approve {this.state.busdSymbol}
                    </h5>
                    <div className="d-flex align-items-center">
                      {!this.state.approving ? (
                        <button
                          type="button"
                          className="btn-close me-2 text-dark"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      ) : null}
                    </div>
                  </div>
                  <div className="modal-body text-dark">
                    <div className="mb-3 d-flex align-items-center">
                      <label className="form-label mb-0 me-4">
                        Your balance:{" "}
                      </label>
                      <span className="h4 text-warning mb-0">
                        {web3.utils.fromWei(this.state.busdBalance)}{" "}
                        {this.state.busdSymbol}
                      </span>
                    </div>
                    <div
                      className="mb-2 d-flex align-items-center justify-content-between"
                      style={{ columnGap: 10 + "px" }}
                    >
                      <span
                        className="ps-0"
                        style={{ border: 0 + "px", whiteSpace: "nowrap" }}
                      >
                        BUSD amount:
                      </span>
                      <input
                        type="number"
                        id="inputAmountApprove"
                        className="form-control ms-2 me-1"
                        min="0"
                        max={web3.utils.fromWei(this.state.busdBalance)}
                        value={web3.utils.fromWei(this.state.approveAmount)}
                        onChange={(e) => {
                          this.setState({
                            approveAmount: web3.utils.toWei(
                              e.target.value === ""
                                ? "0"
                                : web3.utils
                                    .toBN(this.state.busdBalance)
                                    .lt(
                                      web3.utils.toBN(
                                        web3.utils.toWei(e.target.value)
                                      )
                                    )
                                ? web3.utils.fromWei(this.state.busdBalance)
                                : parseFloat(e.target.value) < 0
                                ? 0
                                : e.target.value
                            ),
                          });
                        }}
                        style={{ width: "calc(100% - 12px)" }}
                      />
                      <button
                        className="btn btn-outline-primary"
                        onClick={(e) =>
                          this.setState({
                            approveAmount: this.state.busdBalance,
                          })
                        }
                      >
                        Max
                      </button>
                    </div>
                    <div
                      className="get-start mt-3 text-center mb-2 d-flex"
                      style={{ columnGap: 10 + "px" }}
                    >
                      <button
                        className="btn btn-primary w-100"
                        //data-bs-dismiss="modal"
                        onClick={this.approve}
                        disabled={this.state.approving}
                      >
                        {this.state.approving ? (
                          <Spinner
                            animation="border"
                            variant="warning"
                            size="sm"
                            className="me-2"
                          />
                        ) : null}
                        APPROVE
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </>
        )}
      </>
    );
  }
}

export default withRouter(ProjectDetails);
